import React from "react";
import { Box, FormControl, TextField, Typography } from "@mui/material";
import dayjs from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider, MobileTimePicker } from '@mui/x-date-pickers';

const ReusableDateInput = ({
    DeadLineDate,
    setDeadLineDate,
    valueInput,
    error,
    helperText,
    label,
    fullWidth = false,
    minDate,
    required = false
}) => {


    return (
        <FormControl fullWidth={fullWidth}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#3D3D3D', fontSize: '14px' }}>
                {valueInput}
                {required && valueInput ? <span style={{ color: '#d32f2f' }}> *</span> : null}
            </Typography>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}>
                <DatePicker
                    label={required && label ? `${label} *` : label}
                    inputFormat="DD/MM/YYYY"
                    name="DeadLineDate"
                    minDate={minDate ? dayjs(minDate) : dayjs()}
                    value={DeadLineDate ? dayjs(DeadLineDate) : null}
                    onChange={(newValue) => {
                        if (!newValue) {
                            setDeadLineDate(null);
                        } else {
                            const formatted = dayjs(newValue).format('YYYY-MM-DD');
                            setDeadLineDate(formatted);
                        }
                    }}
                    renderInput={(params) => <TextField size="small" sx={{ minWidth: "100%" }}
                        {...params} error={error} helperText={helperText} inputProps={{
                            ...params.inputProps,
                            pattern: "\\d{2}/\\d{2}/\\d{4}", // only DD/MM/YYYY allowed
                            placeholder: "DD/MM/YYYY",
                            onInput: (e) => {
                                // Strip any invalid characters
                                e.target.value = e.target.value.replace(/[^0-9/]/g, "");
                            },
                        }} />}
                />
            </LocalizationProvider>
        </FormControl>
    );
};

export default ReusableDateInput;
